module.exports = __webpack_public_path__ + "media/src/StayPackage/images/mapPinBlue-c6c92d7d54708ee1ff6221a2bb568c64.svg";